export interface ComicChapter {
  id: number;
  title: string;
  pageCount: number;
  updatedAt: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  followers: number;
  tags: string[];
  chapters: ComicChapter[];
  updatedAt: string;
  createdAt: string;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '家教老师',
    author: '林小风',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20manga%20cover%20illustration%20of%20a%20young%20female%20tutor%20with%20glasses%20and%20a%20warm%20smile%20holding%20a%20textbook%20in%20a%20cozy%20classroom%20setting%20with%20bookshelves%20and%20warm%20lighting%20soft%20pastel%20colors%20anime%20art%20style%20clean%20composition%20with%20white%20background%20borders&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '大学生林小雨在暑假期间成为了一名家庭教师，负责辅导高中生陈默的各门功课。原本以为只是一份普通的兼职，却没想到在朝夕相处中，两人之间产生了微妙的情感变化。温柔的家教老师与叛逆的高中生之间，一段既甜蜜又充满考验的师生恋即将展开……',
    category: 'lianai',
    status: '连载中',
    rating: 9.5,
    views: 1250000,
    followers: 86000,
    tags: ['恋爱', '校园', '师生', '甜宠'],
    chapters: [
      { id: 1, title: '第1话 意外的家教工作', pageCount: 45, updatedAt: '2026-07-28' },
      { id: 2, title: '第2话 初次见面', pageCount: 42, updatedAt: '2026-07-21' },
      { id: 3, title: '第3话 第一次补课', pageCount: 48, updatedAt: '2026-07-14' },
      { id: 4, title: '第4话 图书馆的秘密', pageCount: 40, updatedAt: '2026-07-07' },
      { id: 5, title: '第5话 雨中的告白', pageCount: 50, updatedAt: '2026-06-30' },
      { id: 6, title: '第6话 心跳的距离', pageCount: 44, updatedAt: '2026-06-23' },
      { id: 7, title: '第7话 意外的访客', pageCount: 46, updatedAt: '2026-06-16' },
      { id: 8, title: '第8话 暑假的计划', pageCount: 43, updatedAt: '2026-06-09' },
    ],
    updatedAt: '2026-07-28',
    createdAt: '2026-01-15',
  },
  {
    id: 2,
    title: '剑道至尊',
    author: '云中鹤',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20cover%20of%20a%20young%20swordsman%20in%20traditional%20martial%20arts%20robe%20holding%20a%20glowing%20katana%20with%20intense%20expression%20dramatic%20wind%20effect%20warm%20orange%20and%20red%20color%20palette%20epic%20anime%20art%20style%20with%20clean%20white%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '少年剑客白无尘自幼失去双亲，背负血海深仇踏上剑道修炼之路。在一次次生死搏杀中，他逐渐领悟剑道的至高境界，也揭开了隐藏在江湖背后的惊天阴谋。',
    category: 'rexue',
    status: '连载中',
    rating: 9.3,
    views: 980000,
    followers: 72000,
    tags: ['热血', '武侠', '战斗', '成长'],
    chapters: [
      { id: 1, title: '第1话 血夜', pageCount: 52, updatedAt: '2026-07-26' },
      { id: 2, title: '第2话 拜师', pageCount: 48, updatedAt: '2026-07-19' },
      { id: 3, title: '第3话 初入江湖', pageCount: 50, updatedAt: '2026-07-12' },
      { id: 4, title: '第4话 剑道大会', pageCount: 55, updatedAt: '2026-07-05' },
      { id: 5, title: '第5话 宿命对决', pageCount: 60, updatedAt: '2026-06-28' },
    ],
    updatedAt: '2026-07-26',
    createdAt: '2025-11-20',
  },
  {
    id: 3,
    title: '星辰变',
    author: '天蚕居士',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20cover%20depicting%20a%20cultivator%20floating%20in%20the%20cosmos%20surrounded%20by%20stars%20and%20planets%20flowing%20long%20hair%20and%20elegant%20traditional%20Chinese%20robe%20with%20mystical%20energy%20effects%20deep%20purple%20and%20golden%20cosmic%20background%20with%20clean%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '平凡少年秦羽因无法修炼内功而备受歧视，但他凭借坚韧不拔的意志另辟蹊径，以外功入道。从此踏上了跨越星辰大海的修炼之旅，最终成为掌控天地的绝世强者。',
    category: 'xuanhuan',
    status: '已完结',
    rating: 9.7,
    views: 2300000,
    followers: 150000,
    tags: ['玄幻', '修炼', '热血', '逆袭'],
    chapters: [
      { id: 1, title: '第1话 废柴少年', pageCount: 48, updatedAt: '2026-07-25' },
      { id: 2, title: '第2话 流星泪', pageCount: 52, updatedAt: '2026-07-18' },
      { id: 3, title: '第3话 外功之道', pageCount: 50, updatedAt: '2026-07-11' },
      { id: 4, title: '第4话 初露锋芒', pageCount: 55, updatedAt: '2026-07-04' },
      { id: 5, title: '第5话 星辰之力', pageCount: 58, updatedAt: '2026-06-27' },
      { id: 6, title: '第6话 仙界之门', pageCount: 60, updatedAt: '2026-06-20' },
    ],
    updatedAt: '2026-07-25',
    createdAt: '2025-06-10',
  },
  {
    id: 4,
    title: '每天回家都看到老婆在装死',
    author: '七月流火',
    cover: 'https://readdy.ai/api/search-image?query=A%20cute%20and%20funny%20manga%20cover%20of%20a%20young%20wife%20dramatically%20pretending%20to%20be%20dead%20on%20the%20living%20room%20floor%20while%20her%20husband%20looks%20bewildered%20in%20the%20background%20comedic%20expression%20warm%20cozy%20home%20interior%20soft%20pastel%20colors%20slice%20of%20life%20anime%20art%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '新婚夫妇的爆笑日常！丈夫每天下班回家，都会看到妻子用各种奇葩的方式"装死"。从被面包噎死到被外星人绑架，创意无限的妻子和无奈又好笑的丈夫，演绎了一段让人捧腹又温暖的婚姻生活。',
    category: 'gaoxiao',
    status: '连载中',
    rating: 9.1,
    views: 850000,
    followers: 58000,
    tags: ['搞笑', '日常', '恋爱', '温馨'],
    chapters: [
      { id: 1, title: '第1话 被面包噎死', pageCount: 30, updatedAt: '2026-07-27' },
      { id: 2, title: '第2话 外星人绑架', pageCount: 28, updatedAt: '2026-07-20' },
      { id: 3, title: '第3话 吸血鬼化', pageCount: 32, updatedAt: '2026-07-13' },
      { id: 4, title: '第4话 僵尸末日', pageCount: 30, updatedAt: '2026-07-06' },
      { id: 5, title: '第5话 时间穿越', pageCount: 34, updatedAt: '2026-06-29' },
    ],
    updatedAt: '2026-07-27',
    createdAt: '2026-03-01',
  },
  {
    id: 5,
    title: '迷雾侦探',
    author: '黑白之间',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20detective%20manga%20cover%20showing%20a%20trench%20coat%20wearing%20detective%20standing%20in%20foggy%20street%20at%20night%20holding%20a%20magnifying%20glass%20with%20a%20shadowy%20figure%20in%20the%20background%20noir%20atmosphere%20dark%20moody%20tones%20with%20warm%20streetlamp%20light%20mystery%20thriller%20anime%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '天才侦探苏墨拥有超乎常人的推理能力，在一个个扑朔迷离的案件中抽丝剥茧。当一宗看似普通的失踪案引出一连串惊天秘密时，苏墨发现自己也深陷其中。真相与谎言交织的迷雾中，谁才是真正的幕后黑手？',
    category: 'xuanyi',
    status: '连载中',
    rating: 9.4,
    views: 720000,
    followers: 49000,
    tags: ['悬疑', '推理', '侦探', '都市'],
    chapters: [
      { id: 1, title: '第1话 失踪者', pageCount: 42, updatedAt: '2026-07-24' },
      { id: 2, title: '第2话 第一个线索', pageCount: 45, updatedAt: '2026-07-17' },
      { id: 3, title: '第3话 隐藏的房间', pageCount: 48, updatedAt: '2026-07-10' },
      { id: 4, title: '第4话 目击者', pageCount: 44, updatedAt: '2026-07-03' },
    ],
    updatedAt: '2026-07-24',
    createdAt: '2026-04-15',
  },
  {
    id: 6,
    title: '青春纪念册',
    author: '落樱',
    cover: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20school%20life%20manga%20cover%20showing%20a%20group%20of%20high%20school%20students%20in%20uniforms%20laughing%20together%20under%20cherry%20blossom%20trees%20in%20spring%20sunlight%20streaming%20through%20petals%20soft%20pink%20and%20warm%20yellow%20color%20palette%20nostalgic%20youth%20anime%20art%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '高二三班的同学们即将面临分班，在这最后的时光里，他们决定一起制作一本青春纪念册。每翻开一页，都是一段难忘的回忆——暗恋、友情、梦想、泪水与欢笑，这就是最美好的青春。',
    category: 'xiaoyuan',
    status: '已完结',
    rating: 9.2,
    views: 680000,
    followers: 45000,
    tags: ['校园', '青春', '友情', '治愈'],
    chapters: [
      { id: 1, title: '第1话 樱花飘落的季节', pageCount: 38, updatedAt: '2026-07-22' },
      { id: 2, title: '第2话 同桌的你', pageCount: 40, updatedAt: '2026-07-15' },
      { id: 3, title: '第3话 天台上的秘密', pageCount: 36, updatedAt: '2026-07-08' },
      { id: 4, title: '第4话 校园祭', pageCount: 44, updatedAt: '2026-07-01' },
      { id: 5, title: '第5话 毕业不说再见', pageCount: 50, updatedAt: '2026-06-24' },
    ],
    updatedAt: '2026-07-22',
    createdAt: '2025-09-01',
  },
  {
    id: 7,
    title: '都市夜行者',
    author: '暗影工作室',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylish%20urban%20manga%20cover%20of%20a%20cool%20young%20man%20in%20modern%20streetwear%20standing%20on%20a%20skyscraper%20rooftop%20at%20night%20city%20lights%20sparkling%20below%20neon%20signs%20reflecting%20dark%20blue%20night%20sky%20with%20warm%20city%20glow%20contemporary%20anime%20art%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '在繁华都市的霓虹灯背后，有一群被称为"夜行者"的特殊存在。他们白天是普通上班族，夜晚则化身为维护城市秩序的侠客。主角陆凡在一次意外中觉醒能力，加入了这个秘密组织，开始了他白天码代码、晚上打怪兽的双面人生。',
    category: 'dushi',
    status: '连载中',
    rating: 8.9,
    views: 550000,
    followers: 38000,
    tags: ['都市', '异能', '动作', '热血'],
    chapters: [
      { id: 1, title: '第1话 普通上班族', pageCount: 42, updatedAt: '2026-07-23' },
      { id: 2, title: '第2话 觉醒之夜', pageCount: 46, updatedAt: '2026-07-16' },
      { id: 3, title: '第3话 夜行者联盟', pageCount: 44, updatedAt: '2026-07-09' },
      { id: 4, title: '第4话 第一次任务', pageCount: 48, updatedAt: '2026-07-02' },
    ],
    updatedAt: '2026-07-23',
    createdAt: '2026-05-10',
  },
  {
    id: 8,
    title: '银河边境',
    author: '星河舰队',
    cover: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20manga%20cover%20showing%20a%20female%20spaceship%20pilot%20in%20sleek%20space%20suit%20looking%20out%20at%20a%20vast%20galaxy%20with%20stars%20and%20nebula%20a%20massive%20spaceship%20in%20the%20background%20cool%20silver%20and%20deep%20space%20blue%20tones%20sci-fi%20anime%20art%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '公元2350年，人类已经遍布银河系。在遥远的银河边境，一支探险舰队发现了未知的外星文明遗迹。舰长林星辰带领船员深入探索，却意外触发了沉睡万年的宇宙秘密。人类的命运，将在这场星际冒险中被彻底改变。',
    category: 'kehuan',
    status: '连载中',
    rating: 9.0,
    views: 490000,
    followers: 35000,
    tags: ['科幻', '太空', '冒险', '机甲'],
    chapters: [
      { id: 1, title: '第1话 启航', pageCount: 48, updatedAt: '2026-07-20' },
      { id: 2, title: '第2话 未知信号', pageCount: 50, updatedAt: '2026-07-13' },
      { id: 3, title: '第3话 外星遗迹', pageCount: 52, updatedAt: '2026-07-06' },
      { id: 4, title: '第4话 苏醒', pageCount: 55, updatedAt: '2026-06-29' },
    ],
    updatedAt: '2026-07-20',
    createdAt: '2026-02-28',
  },
  {
    id: 9,
    title: '异世界药局',
    author: '药丸君',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20cover%20of%20a%20young%20pharmacist%20in%20medieval%20fantasy%20setting%20surrounded%20by%20magical%20herbs%20and%20potions%20in%20glass%20bottles%20with%20glowing%20effects%20warm%20wooden%20pharmacy%20interior%20soft%20magical%20atmosphere%20charming%20isekai%20anime%20art%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '现代药剂师林药 inexplicably穿越到异世界，发现这里的医疗水平还停留在中世纪。凭借现代药学知识，他在异世界开设了第一家正规药局，用科学的方法治愈各种奇难杂症，逐渐成为人们口中的"药神"。',
    category: 'xuanhuan',
    status: '连载中',
    rating: 9.3,
    views: 780000,
    followers: 52000,
    tags: ['玄幻', '穿越', '医疗', '冒险'],
    chapters: [
      { id: 1, title: '第1话 穿越', pageCount: 44, updatedAt: '2026-07-19' },
      { id: 2, title: '第2话 异世界的疾病', pageCount: 46, updatedAt: '2026-07-12' },
      { id: 3, title: '第3话 第一间药局', pageCount: 42, updatedAt: '2026-07-05' },
      { id: 4, title: '第4话 瘟疫来袭', pageCount: 50, updatedAt: '2026-06-28' },
      { id: 5, title: '第5话 王都召唤', pageCount: 48, updatedAt: '2026-06-21' },
    ],
    updatedAt: '2026-07-19',
    createdAt: '2026-01-10',
  },
  {
    id: 10,
    title: '心动信号',
    author: '薄荷糖',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20manga%20cover%20of%20a%20couple%20sitting%20on%20a%20park%20bench%20under%20cherry%20blossom%20trees%20shyly%20holding%20hands%20with%20pink%20petals%20falling%20around%20them%20soft%20golden%20sunset%20light%20warm%20romantic%20atmosphere%20shoujo%20anime%20art%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '程序员顾言之和插画师夏晚晚是邻居，两人因为一面之隔的阳台而相识。从最初的点头之交，到一起分享早餐、互相鼓励，两颗孤独的心在都市丛林中慢慢靠近。这是一个关于成年人之间温柔又克制的爱情故事。',
    category: 'lianai',
    status: '连载中',
    rating: 9.4,
    views: 920000,
    followers: 61000,
    tags: ['恋爱', '都市', '温馨', '治愈'],
    chapters: [
      { id: 1, title: '第1话 隔壁的她', pageCount: 36, updatedAt: '2026-07-18' },
      { id: 2, title: '第2话 阳台上的早餐', pageCount: 38, updatedAt: '2026-07-11' },
      { id: 3, title: '第3话 加班夜', pageCount: 40, updatedAt: '2026-07-04' },
      { id: 4, title: '第4话 失控的心跳', pageCount: 42, updatedAt: '2026-06-27' },
      { id: 5, title: '第5话 表白计划', pageCount: 44, updatedAt: '2026-06-20' },
    ],
    updatedAt: '2026-07-18',
    createdAt: '2026-03-20',
  },
  {
    id: 11,
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20cultivation%20manga%20cover%20showing%20a%20powerful%20young%20warrior%20with%20flame%20aura%20surrounding%20him%20holding%20a%20massive%20heavy%20ruler%20weapon%20standing%20on%20a%20mountain%20peak%20dramatic%20orange%20and%20red%20sky%20dynamic%20action%20anime%20art%20style%20with%20clean%20composition&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，种种打击接踵而至。就在他即将绝望之时，一缕灵魂从他手上的戒指里浮现，一扇全新的大门就此开启！',
    category: 'rexue',
    status: '连载中',
    rating: 9.6,
    views: 3500000,
    followers: 210000,
    tags: ['热血', '玄幻', '修炼', '逆袭'],
    chapters: [
      { id: 1, title: '第1话 天才陨落', pageCount: 50, updatedAt: '2026-07-30' },
      { id: 2, title: '第2话 戒指中的灵魂', pageCount: 48, updatedAt: '2026-07-23' },
      { id: 3, title: '第3话 重拾信心', pageCount: 52, updatedAt: '2026-07-16' },
      { id: 4, title: '第4话 迦南学院', pageCount: 55, updatedAt: '2026-07-09' },
      { id: 5, title: '第5话 内院选拔', pageCount: 58, updatedAt: '2026-07-02' },
      { id: 6, title: '第6话 强者之战', pageCount: 60, updatedAt: '2026-06-25' },
    ],
    updatedAt: '2026-07-30',
    createdAt: '2025-01-01',
  },
  {
    id: 12,
    title: '魔道祖师',
    author: '墨香铜臭',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20cultivation%20manga%20cover%20featuring%20an%20elegant%20man%20in%20flowing%20black%20and%20red%20traditional%20robes%20playing%20a%20flute%20with%20ghostly%20spiritual%20energy%20swirling%20around%20mysterious%20dark%20atmosphere%20with%20moonlight%20ancient%20Chinese%20aesthetic%20danmei%20art%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '夷陵老祖魏无羡死后十三年，被人用一个禁术献舍重生。重生后的魏无羡遇到了故人蓝忘机，两人一起调查一具被肢解的尸体，由此卷入了一桩涉及修真界各大世家的惊天阴谋。',
    category: 'xuanhuan',
    status: '已完结',
    rating: 9.8,
    views: 4200000,
    followers: 280000,
    tags: ['玄幻', '仙侠', '悬疑', '经典'],
    chapters: [
      { id: 1, title: '第1话 重生', pageCount: 46, updatedAt: '2026-07-29' },
      { id: 2, title: '第2话 莫家庄', pageCount: 50, updatedAt: '2026-07-22' },
      { id: 3, title: '第3话 鬼手', pageCount: 48, updatedAt: '2026-07-15' },
      { id: 4, title: '第4话 故人重逢', pageCount: 52, updatedAt: '2026-07-08' },
      { id: 5, title: '第5话 义城篇', pageCount: 56, updatedAt: '2026-07-01' },
    ],
    updatedAt: '2026-07-29',
    createdAt: '2025-03-15',
  },
];